import { TaskStatus } from '@nexelem/graphne-api';

export const getColumnId = (queueId: number, taskStatus: TaskStatus) => `${queueId}-${taskStatus}`;

export const parseColumnId = (columnId = '') => {
  const [queueId, taskStatus] = columnId.split('-');

  return {
    queueId: queueId ? queueId : undefined,
    status: taskStatus ? (taskStatus as TaskStatus) : undefined,
  };
};
